<template>
  <div class="history">
    <history-filter-block
      :is-load-xml="condition.idLoadXml"
      @download-xls="downloadXls()"
      :is-load-data="condition.isLoadTable"
      :orders="orders"
      :init-wholly-orders="initWhollyList"
      :loading-parent="loadAllData"
      :all-orders="allOrders"
      :data-list-acts="listActs"
      :orders-view-mode="ordersViewMode"
      @init-list-acts-terminate="initListTerminateActs"
      @generate-pdf-preview="generatePdfPreview"
      @trash-acts-list="trashActsListFunc"
      @init-orders-list="initList(true)"
      @update-orders-list="updateOrdersList"
      @show-acts-column="showActsColumn"
      @change-orders-view="changeOrdersView"
      class="mb-2"
      ref="filter"
    ></history-filter-block>
    <orders-list
      ref="orderList"
      @init-orders-list="initList"
      :init-wholly-orders="initWhollyList"
      :trash-acts-list="trashActsList"
      :filter-button-event="filterButtonEvent"
      :list-acts-terminated="listActsTerminated"
      @init-list-acts="initListActs"
      @filter-status-wrap="filterStatusWrap()"
      @init-load-all-data="initLoadAllData"
      @generate-pdf-preview="generatePdfPreview"
      @change-orders-view="changeOrdersView"
      :count-prolongation="countProlongation"
      :show-acts-column-status="showActsColumnStatus"
      :is-load-data="condition.isLoadTable"
      :orders="orders"
      :all-orders="allOrders"
      :orders-view-mode="ordersViewMode"
    ></orders-list>
    <!--        :is-mobile="this.condition.isMobile"-->
    <div style="text-align: center" class="pagination-block history-pagination">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="initList()"
      />
    </div>

    <!--        <dialog ref="pdfDialog" style="width: 90%; height: 90%; border: 0px;">
            <div style="height: 90%;">
                <iframe :src="pdfUrl" width="100%" height="100%" frameborder="0"></iframe>
            </div>
            <div style="text-align: center; margin-top: 10px;">
                <button @click="sendAct" style="margin-right: 15px;" class="btn btn-orange">Відправити акт на виплату</button>
                <button @click="closePdf" class="btn btn-outline-info">Закрити</button>
            </div>
        </dialog>-->

    <dialog ref="pdfDialog" style="width: 90%; height: 90%; border: 0px;">
      <div style="height: 90%;">
        <iframe
          v-if="activePdfUrl"
          :src="activePdfUrl"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
        <div v-else class="pdf-placeholder">
          Выберите PDF для просмотра
        </div>
      </div>

      <div style="text-align: center; margin-top: 10px;">
        <button
          v-for="(pdfUrl, index) in pdfUrls"
          @click="setActivePdf(pdfUrl)"
          :class="[
            'btn',
            activePdfUrl === pdfUrl ? 'btn-primary' : 'btn-info'
          ]"
          style="margin-right: 15px;"
        >
          {{ index }}
        </button>
        <button
          @click="sendAct"
          style="margin-right: 15px;"
          class="btn btn-orange"
          v-loading="loadingSendAct"
          :disabled="loadingSendAct"
        >
          Відправити акт на виплату
        </button>
        <button @click="closePdf" class="btn btn-outline-info">Закрити</button>
      </div>
    </dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { orderMixin } from '@/mixin';
import Pagination from '@/components/Pagination';
import {
  list as listOrders,
  prolongation as listProlongation,
  downloadExcel,
  whollyList
} from "@/api/order";
import { default as ordersList } from "@/views/history/ordersList";
import { default as HistoryFilterBlock } from "@/views/history/filterBlock";
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";

const FileDownload = require('js-file-download');

export default {
  mixins: [orderMixin],
  components: {
    ordersList,
    Pagination,
    HistoryFilterBlock
  },
  data: function() {
    return {
      pdfUrls: {},
      pdfUrl: '',
      activePdfUrl: null,
      payoutActId: null,
      payoutActData: [],
      finalSum: null,
      filterButtonEvent: false,
      requestSeq: 0,
      loadAllData: false,
      loadingSendAct: false,
      orders: [],
      allOrders: [],
      total: 1,
      trashActsList: false,
      countProlongation: 0,
      mobileWith: 992,
      listActsTerminated: {},
      listActs: {},
      showActsColumnStatus: false,
      ordersViewMode: 'full',
      condition: {
        isLoadTable: true,
        isLoadXml: false,
        // isMobile: false,
      },
      listQuery: {
        page: 1,
        limit: 10,
        terminated: false,
      },
    }
  },
  // created: function() {
  //     window.addEventListener("resize", this.checkWindowResize);
  //     this.checkIsMobile();
  // },
  mounted: function() {
    // The hook. Here, Vue has already worked its magic.
    this.$store.dispatch('GET_USERINFO');
    if (this.$route.query.orderId) {
      this.$refs.filter.listQuery.orderId = this.$route.query.orderId;
      this.$refs.filter.condition.isShowFilter = true;
    }
    if (this.$route.query.dateFrom) {
      this.$refs.filter.applyDateFromQuery(this.$route.query.dateFrom);
    }
    this.initList();
  },
  computed: {
    margeActsList: function() {
      return {
        ...this.listActsTerminated,
        ...this.listActs,
      };
    },
    amountBalance() {
      return this.$store.state.transactionsStore.all.amount;
    },
  },
  watch: {

  },
  methods: {
    // checkIsMobile: function() {
    //     return this.condition.isMobile = window.innerWidth < this.mobileWith;
    // },
    // checkWindowResize: function() {
    //     this.checkIsMobile()
    // },
    setActivePdf(url) {
      this.activePdfUrl = url;
    },
    showActsColumn: function(status) {
      this.showActsColumnStatus = status;
    },
    updateOrdersList: function(orders) {
      this.orders = orders;
    },
    filterStatusWrap: function() {
      this.$refs.filter.filterStatusWrap(true);
    },
    initLoadAllData: function(loadAllData) {
      this.loadAllData = loadAllData;
    },
    changeOrdersView() {
      this.ordersViewMode = this.ordersViewMode === 'full' ? 'compact' : 'full';
    },
    getQuery: function() {
      return {
        ...this.$refs.filter.listQuery,
        ...this.$refs.orderList.listQuery,
        ...this.listQuery
      };
    },
    downloadXls: async function() {
      Vue.set(this.condition, 'idLoadXml', true);

      try {
        let response = await downloadExcel(this.getQuery());

        if (response?.data) {
          FileDownload(response.data, 'report.xlsx');
        }
      } catch (e) {
        console.error('Download excel error:', e);
        this.$message.error('Помилка при завантаженні Excel файлу');
      } finally {
        Vue.set(this.condition, 'idLoadXml', false);
      }
    },
    initListTerminateActs: function(listActs) {
      this.listActsTerminated = listActs;
    },
    initListActs: function(listActs) {
      this.listActs = listActs;
    },
    trashActsListFunc: function() {
      this.trashActsList = true;
    },
    initList: async function(filterButtonEvent) {
      this.filterButtonEvent = filterButtonEvent;
      if (filterButtonEvent === true) {
        this.listQuery.page = 1;
      }
      const seq = ++this.requestSeq;
      let response;
      this.orders = [];
      this.condition.isLoadTable = true;

      if (
        this.$refs.orderList.listQuery.statusId === this.prolongationStatus.id
      ) {
        response = await listProlongation(this.getQuery());
      } else {
        response = await listOrders(this.getQuery());
      }
      if (seq !== this.requestSeq) return;
      const { data } = response;

      this.countProlongation = data.data?.countProlongation ?? data.data?.total;
      this.orders = data.data.items;
      this.total = data.data?.total;
      this.condition.isLoadTable = false;
    },
    initWhollyList: async function(filterButtonEvent, terminated = false) {
      if (filterButtonEvent === true) {
        this.listQuery.page = 1;
      }
      this.listQuery.terminated = terminated;
      let getQuery = this.getQuery();
      if (terminated) {
        //delete getQuery.fromDate;
        //delete getQuery.toDate;
        delete getQuery.fromToDate;
      }
      let response;
      this.allOrders = [];
      response = await whollyList(getQuery);
      const { data } = response;
      this.allOrders = data.data.allItems;
    },
    calculateTotalEarnings(offers) {
      return Object.values(offers).reduce((sum, offer) => {
        let osago = parseFloat(offer.myOsagоEarning || 0);
        osago = osago > 1 ? osago : 0;
        const dgo = parseFloat(offer.myDgoEarning || 0);
        const autolawyer = parseFloat(offer.myAutolawyerEarning || 0);
        let earnings = parseFloat(offer.allEarnings || offer.myEarnings || 0);
        earnings = earnings > 1 ? earnings : 0;
        const bonusAmount = parseFloat(offer.bonusAmount || 0);
        const acquiring = parseFloat(offer.acquiring || 0);

        if (osago > 0) {
          return sum + osago + dgo + autolawyer + bonusAmount;
        } else {
          return sum + earnings + bonusAmount;
        }
      }, 0);
    },
    async generatePdfPreview() {
      let paySum = this.calculateTotalEarnings(this.margeActsList);
      //console.log('this.amountBalance',this.amountBalance);
      //console.log('Number(parseFloat(paySum).toFixed(2))',Number(parseFloat(paySum).toFixed(2)));
      //console.log('Number(parseFloat(this.amountBalance).toFixed(2))',Number(parseFloat(this.amountBalance).toFixed(2)));
      if (
        Number(parseFloat(paySum).toFixed(2)) >
        Number(parseFloat(this.amountBalance).toFixed(2))
      ) {
        this.$alert(
          "<h3>Увага! При спробі передати акт на виплату виникла помилка</h3> <hr><br>" +
            "<p class='content-box'>Сума КВ за обрані поліси не дорівнює сумі коштів на балансі.<br>Будь ласка, оберіть інші договори.</p>",
          {
            dangerouslyUseHTMLString: true,
            customClass: 'wide-alert-dialog',
            confirmButtonText: 'Редагувати акт',
          }
        );
        return;
      }

      if (Object.keys(this.margeActsList).length == 0) {
        this.$alert("Оберіть спочатку поліси для формування акту", '', 'error');
        return;
      }
      this.loadAllData = true;
      try {
        const response = await axios.post(
          '/api/report/generate-preview',
          {
            data: this.margeActsList
          },
          { responseType: "json" }
        );

        if (response.data.success) {
          this.payoutActData = [];
          this.pdfUrls = {};
          response.data.acts.forEach((item, index) => {
            this.pdfUrls[item.tov_short] = item.path;
            if (index == 0) {
              const firstKey = Object.keys(this.pdfUrls)[0];
              const firstValue = this.pdfUrls[firstKey];
              this.setActivePdf(firstValue);
            }
            this.payoutActData.push({
              id: item.payoutActId,
              finalSum: item.finalSum,
              orders: item.orders_id
            });
            //this.finalSum = item.finalSum;
          });

          //this.pdfUrl = response.data.path;

          //this.payoutActId = response.data.payoutActId;
          //this.finalSum = response.data.finalSum;
          this.$refs.pdfDialog.showModal();
        } else {
          this.$alert(
            "<h3>Увага! При спробі передати акт на виплату виникла помилка</h3> <hr><br>" +
              "<p class='content-box'>" +
              response.data.error +
              "</p>",
            {
              dangerouslyUseHTMLString: true,
              customClass: 'wide-alert-dialog',
              confirmButtonText: 'Перейти в профіль',
            }
          ).then(() => {
            this.$router.push({ name: 'profile' });
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadAllData = false;
      }
    },
    closePdf() {
      this.$refs.pdfDialog.close();
      axios
        .post('/api/delete/act', {
          ids: this.payoutActData,
          paths: this.pdfUrls
        })
        .then(({ data }) => {})
        .catch(err => console.log(err));
    },
    sendAct() {
      if (this.loadingSendAct) return;
      this.loadingSendAct = true;
      const ids = Object.values(this.margeActsList).map(item => item.id);
      let params = {
        "orderIds": ids,
        "pdfUrls": this.pdfUrls,
        "payoutActIds": this.payoutActData,
      };
      axios
        .post('/api/add/act', params)
        .then(({ data }) => {
          if (Array.isArray(data) && data.length > 0) {
            data.forEach(result => {
              if (result?.payoutAct && typeof result.payoutAct === 'object') {
                Object.entries(result.payoutAct).forEach(
                  ([orderId, actData]) => {
                    const order = this.orders.find(o => o.id === orderId);
                    if (order) {
                      this.$set(order, 'act', actData);
                    }
                  }
                );
              }
            });
          }
        }).catch(err => console.log(err));

      this.$refs.pdfDialog.close();
    },
  },
  // destroyed() {
  //     window.removeEventListener("resize", this.checkWindowResize);
  // },
}
</script>
